import { render } from "./CopyIcon.vue?vue&type=template&id=6d4d9d00&scoped=true"
import script from "./CopyIcon.vue?vue&type=script&lang=js"
export * from "./CopyIcon.vue?vue&type=script&lang=js"

import "./CopyIcon.vue?vue&type=style&index=0&id=6d4d9d00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4d9d00"]])

export default __exports__